import styled from "styled-components";
import { theme } from "ui";

export interface ButtonProps {
  width?: string;
  color?: string;
  fontSize?: string;
  fontWeight?: string | number;
  isDisabled?: boolean;
  scaleMedia?: number;
  sizeProps?: boolean;
}
export interface TextPros {
  textVisibleMobile: boolean;
}

export const TextButtonCart = styled.span<TextPros>`
  font-size: 1.25rem;

  @media ${theme.device.desktopFirst.mobileL} {
    font-size: ${({ textVisibleMobile }) =>
      textVisibleMobile ? "1.15rem" : "1.25rem"};
  }
`;

export const Button = styled.button<ButtonProps>`
  display: flex;
  border: none;
  border-radius: 4px;
  gap: 8px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: ${({ width }) => width || theme.space.x32};
  background-color: ${theme.colors.secondary["300"]};
  z-index: 1;
  position: relative;

  &:not(:disabled):hover {
    filter: brightness(0.9);
  }

  &:disabled {
    cursor: not-allowed;
    pointer-events: none;
    opacity: 0.5;
  }

  padding: 1rem;
  color: ${({ color }) => color || theme.colors.neutral.white};
  font-size: ${({ fontSize }) => fontSize ?? "1.5rem"};
  font-weight: ${theme.typography.fontWeight.bold};
  transition: filter 0.2s ease-in-out;

  @media ${theme.device.desktopFirst.laptop} {
    transform: scale(${({ scaleMedia }) => scaleMedia ?? 1});
    padding: 1.2rem 3rem;
  }

  @media ${theme.device.desktopFirst.tabletS} {
    padding: 1rem;
    width: 20rem;
  }

  @media ${theme.device.desktopFirst.mobileXL} {
    transform: scale(1);
    height: ${({ sizeProps }) => (sizeProps ? "36px" : "48px")};
    width: ${({ sizeProps }) => (sizeProps ? "116px" : "initial")};
    border-radius: 4px;
    padding: 0.75rem;
  }
`;

export const CartIconWrapper = styled.div`
  min-height: 18px;
  min-width: 18px;

  display: flex;
  align-items: center;
  justify-content: center;
`;
